import { createFileRoute } from "@tanstack/react-router";
import { BarkMapComponent } from "../../components/bark_classic/BarkMapComponent";

export const Route = createFileRoute("/app/bark_classic")({
  component: RouteComponent,
});

function RouteComponent() {
  return <BarkMapComponent />;
}
